import FieldValidator from "../field-validator/FieldValidator";
import HttpClient from "../client/httpclient";
import Loader from "../loading/loader";
import { GATracking } from "../../utils/webtracking";
import { loadReCaptcha, getRecaptcha } from "../../utils/helpers";
import 'regenerator-runtime/runtime';

class SignUpForm {
    constructor(DOMelement) {
        try {
            this.el = DOMelement;
            this.fieldsets = this.el.querySelectorAll(".sd-fieldset");
            this.checkValidity = this.checkValidity.bind(this);
            this.validateButton = this.el.querySelectorAll(".sd-button--primary");
            this.validate = this.validate.bind(this);
            this.submitForm = this.submitForm.bind(this);
            this.handleFormStatus = this.handleFormStatus.bind(this);
            this.validateButton.forEach((button) =>
                button.addEventListener("click", this.validate)
            );
            this.actionUrl = this.el.getAttribute("action");
            this.method = "POST";
            if (process.env.NODE_ENV === "development") {
                this.actionUrl = "/src/api/signup-api-response.json";
            }
            this.loaderEl = this.el.querySelector(".sd-loading");

            this.loader = new Loader(this.loaderEl);

            // add initial event listener to the form inputs.
            const recaptchaInputs = this.el.querySelectorAll(".sd__input-recaptcha");
            [...recaptchaInputs].forEach((input) => {
                input.addEventListener('focus', loadReCaptcha, false);
            })
        } catch (error) {
            console.log(error);
        }
    }

    validate(event) {
        event.preventDefault();
        if (this.loader) {
            this.loader.show();
            document.querySelector(".page-form-submit").style.fontSize = "0px";
            document.getElementById("full-page-overlay").style.display = "block";
        }
        if (this.checkValidity(this.fieldsets)) {
            GATracking.formValidation('error_tracking', 'newsletter signup', 'success');
            this.submitForm();
        } else {
            GATracking.formValidation('error_tracking', 'newsletter signup', 'fail');
            if (this.loader) {
                this.loader.hide();
                document.querySelector(".page-form-submit").style.fontSize = "12px";
                document.getElementById("full-page-overlay").style.display = "none";
            }
        }
    }

    checkValidity(fieldsets) {
        const validatedFieldsets = [...fieldsets].map((form) =>
            new FieldValidator(form).validate()
        );
        return validatedFieldsets.every((isValid) => !!isValid);
    }

    async submitForm() {
        await getRecaptcha("inline-badge-signup", ".recaptchaResponseSignup");
        const data = new FormData(this.el);
        await HttpClient.AsyncPostRequest(this.actionUrl, data, this.method)
            .then(this.handleFormStatus)
            .catch(this.displayError);
    }

    handleFormStatus(response) {
        let form = this.el;
        if (response) {
            this.el.nextElementSibling.classList.remove("sd-form__status-error");
            this.el.nextElementSibling.classList.add("sd-form__status-success");
            if (JSON.parse(response).success == true) {
                window.location.href = JSON.parse(response).url;
            }
            this.el.nextElementSibling.innerHTML = JSON.parse(response).result;
            GATracking.formValidation('form_submission', 'newsletter signup', 'success');
            GATracking.eventTracking('footer_click', 'footer', 'newsletter signup', 'success')
        } else {
            this.displayError();
        }
        if (this.loader) {
            this.loader.hide();
            document.querySelector(".page-form-submit").style.fontSize = "12px";
            document.getElementById("full-page-overlay").style.display = "none";
        }
        form.remove();
    }

    displayError() {
        GATracking.formValidation('form_submission', 'newsletter signup', 'fail');
        GATracking.eventTracking('footer_click', 'footer', 'newsletter signup', 'fail');
        this.el.nextElementSibling.classList.remove("sd-form__status-success");
        this.el.nextElementSibling.classList.add("sd-form__status-error");
        this.el.nextElementSibling.innerHTML =
            "Something went wrong. Please try again or contact us.";
    }
}

export default SignUpForm;
